import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=ca040a7e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca040a7e')) {
      api.createRecord('ca040a7e', component.options)
    } else {
      api.reload('ca040a7e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=ca040a7e&", function () {
      api.rerender('ca040a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28dI46vaWZtYc/JS/comp/ErrorMessage.vue"
export default component.exports